import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { thunk } from "redux-thunk";
import adminDataSlice from "./slices/adminDataSlice"
import usersDataSlice from "./slices/userDataSlice"
import userDetailSlice from "./slices/userDetailSlice"
import hobbyDataSlice from "./slices/hobbyDataSlice"
import faqDataSlice from "./slices/faqDataSlice"
import reportedDataSlice from "./slices/reportedUserSlice"
import foulWordsSlice from "./slices/foulWordsSlice"

// Combine all reducers
const rootReducer = combineReducers({
    adminData: adminDataSlice,
    userData: usersDataSlice ,
    userDetail: userDetailSlice,
    hobbyData: hobbyDataSlice,
    faqData:faqDataSlice,
    reportedUsers:reportedDataSlice,
    foulWordsDetails: foulWordsSlice
});

// Persist Configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["adminData"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create Store
export const makeStore = () => {
  return configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      })
      // .concat(thunk),
  });
};

export const store = makeStore();
export const persistor = persistStore(store);

export default store;
